import { forwardRef } from "react";
import type { LucideProps } from "lucide-react";

/**
 * X (formerly Twitter) brand icon. Filled glyph (NOT stroke-based) because
 * the X mark is a solid wordmark in brand guidelines. The signature still
 * matches `LucideIcon` so it can be interchanged with lucide-react icons
 * referenced from `src/lib/footerLinks.ts`.
 *
 * lucide-react does not ship an X / Twitter icon (deprecated in v0.265+
 * with the company's rebrand to X). We are pinned to ^0.462.0 per the
 * shadcn migration locked-versions table.
 */
export const XIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      className,
      size = 24,
      color = "currentColor",
      // X is a filled glyph; we ignore stroke-related props on purpose so the
      // call-site can pass them uniformly with stroke-based icons without
      // breaking the visual.
      strokeWidth: _strokeWidth,
      ...rest
    },
    ref,
  ) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
      className={className}
      {...rest}
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
);

XIcon.displayName = "XIcon";
